<template>
  <div class="service_manage" >
    <el-divider content-position="left">B端商户管理</el-divider>
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <el-button type="primary" size="small" @click="handleAddOpen">新增</el-button>
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </el-col>
    </el-row>
    <el-table :data="serviceProvider" size="medium" style="width: 100%" border>
      <el-table-column label='ID'>
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label='B端商户名称'>
        <template slot-scope="scope">
          {{ scope.row.business_name }}
        </template>
      </el-table-column>
      <el-table-column label='联系人'>
        <template slot-scope="scope">
          {{ scope.row.contact_user }}
        </template>
      </el-table-column>
      <el-table-column label='联系方式'>
        <template slot-scope="scope">
          {{ scope.row.contact_methods }}
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="80">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" icon="el-icon-edit" circle 
          @click="handleEditOpen(scope.$index, scope.row)">
          </el-button>
          <el-popconfirm @onConfirm="handleDelete(scope.$index, scope.row)" confirmButtonText='确定'
            cancelButtonText='取消' icon="el-icon-info" iconColor="red" title="确定删除吗？">
            <el-button size="mini" type="danger" slot="reference" icon="el-icon-delete" circle>
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!--页码-->
    <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper" :hide-on-single-page="false"
      :current-page="pageOption.currentPage" :page-sizes="[10, 20]" :page-size="pageOption.pageSize"
      :total="pageOption.total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 添加-->
    <el-drawer title="添加" :visible.sync="addDrawer" :direction="direction" :before-close="handleClose"
      size="40%">
      <div class="m-tabs-content">
        <el-form :model="formData" label-width="120px" :rules="rules" ref="formData">
          <el-form-item label="B端商户名称" prop="business_name">
            <el-input type="text" size="mini" placeholder="请输入B端商户名称" v-model="formData.business_name"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contact_user">
            <el-input type="text" size="mini" placeholder="请输入联系人" v-model="formData.contact_user"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="contact_methods">
            <el-input type="text" size="mini" placeholder="请输入联系方式" v-model="formData.contact_methods"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="float: right;margin-top: .4rem;" size="mini"
              @click="submitCheckForm('formData')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: 'service_manage',
  data () {
    return {
      inputSize: 'small',
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      addDrawer: false,
      saveDrawer: false,
      direction: 'rtl',
      serviceProvider: [],
      formData: {
        id: '',
        business_name: '',
        contact_user: '',
        contact_methods: ''
      },
      rules: {
        business_name: [
          { required: true, message: '请输入服务商名称', trigger: 'blur' }
        ],
        contact_user: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contact_methods: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ]
      },
      listSort: [],
    }
  },
  computed: { 
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }
      return str
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getServiceProviderList () {
      this.$axios
        .get(
          '/api/admin/service_provider/list?page=' +
          this.pageOption.currentPage,
        )
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.serviceProvider = data.data.data.data
            this.pageOption.total = data.data.data.total
            this.pageOption.currentPage = data.data.data.current_page
            this.loadSort()
          }
        })
    },
    handleAddOpen () {
      this.addDrawer = true
    },
    submitCheckForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios.post('/api/admin/service_provider', { formData: this.formData }).then((res) => {
            let { data } = res
            if (data.code === 0) {
              this.addDrawer = false
              this.getServiceProviderList()
              this.$message.success(data.msg)
            } else {
              this.$message.error(data.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    handleEditOpen (index, row) {
      this.formData.id = row.id
      this.formData.business_name = row.business_name
      this.formData.contact_user = row.contact_user
      this.formData.contact_methods = row.contact_methods
      this.addDrawer = true
    },
    handleDelete (index, row) {
      this.$axios.get("/api/admin/service_provider/delete?id=" + row.id).then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.$message.error(data.msg)
          this.getServiceProviderList()
        }
      }).catch(_ => {})
    },
    loadSort () {
      this.serviceProvider.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .post('api/admin/service_provider/set_sort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getServiceProviderList()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
      this.getServiceProviderList()
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getServiceProviderList()
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.clearSaveData()
          done()
        })
        .catch(_ => {
        })
    },
    clearSaveData () {
      this.formData.id = ''
      this.formData.business_name = '',
      this.formData.contact_user = '',
      this.formData.contact_methods = ''
    },
  },
  mounted () {
    this.getServiceProviderList()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span
    color: #4c87fc
    font-size 0.36rem
    font-weight 400
  .service_manage
    marginLeft()
  .mt-10
    margin-top: .2rem
  .tr
    text-align: right
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    overflow-y auto
    .m-label
      line-height: .64rem
    .el-row
      margin-bottom: .4rem
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width: 100%
    .el-select
      width: 100%
  .service_manage >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .addCon
    padding: .2rem
    text-align: right
  .count_style
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/ServiceProvider.vue